// extracted by mini-css-extract-plugin
export default {"container":"ModalServicesCategory_container__2Hz2+","new":"ModalServicesCategory_new__b6ZQ-"};